module.exports = __webpack_public_path__ + "img/3.6503e1dd.svg";